import { combineReducers } from "redux"
import { devToolsReducer } from "./DevTools/reducer"
import { dynamicFormPaletteReducer } from "./DyanmicFormPalette/reducer"
import { featuresReducer } from "./features/reducer"
import { hrReportsReducer } from "./Hr_Reports/reducer"
import { junkDrawerReducer } from "./JunkDrawer/reducer"
import { leaseApprovalsReducer } from "./LeaseApprovals/reducer"
import { menuReducer } from "./Menus/reducer"
import { serverStatusReducer } from "./ServerStatus/reducer"
import { userReferenceReducer } from "./UserReference/reducer"
import { userReducer } from "./user/reducer"

const rootReducer = combineReducers({
	menu: menuReducer,
	user: userReducer,
	hrReports: hrReportsReducer,
	devTools: devToolsReducer,
	userReference: userReferenceReducer,
	junkDrawer: junkDrawerReducer,
	dynamicFormPalette: dynamicFormPaletteReducer,
	serverStatus: serverStatusReducer,
	features: featuresReducer,
	leaseApprovals: leaseApprovalsReducer,
})

export type AppState = ReturnType<typeof rootReducer>

export default rootReducer
